module.exports = __webpack_public_path__ + "img/14.beea6687.jpg";